import { processRawInput } from "./processRawInput";
import userShare from "./userShare";
import ItemPlugin from "./YouTubeItem/YouTubeItem";

export default function registerYouTubePlugin() {
  return { ItemPlugin, userShare, processRawInput };
}
